import { SimpleDataStore } from './simple-data-store.js';
import { KeyValueStore } from './key-value-store.js';
import { UniversalMemoryStorage } from './universal-memory-storage.js';
import { getGlobalThis } from './global-this.js';
const storageId = 'memory-storage';
export const memoryStorage = getOrCreateMemoryStorage();
export function useMemoryData(id, data) {
    return () => {
        if (!memoryStorage.has(id)) {
            memoryStorage.set(id, data());
        }
        return memoryStorage.get(id);
    };
}
/**
 * @deprecated please use 'useMemoryData()' instead
 */
export function getOrCreateMemoryDataStore(id) {
    if (!memoryStorage.has(id)) {
        memoryStorage.set(id, new SimpleDataStore());
    }
    return memoryStorage.get(id);
}
/**
 * @deprecated please use 'useMemoryData()' instead
 */
export function getOrCreateMemoryCacheStore(id) {
    if (!memoryStorage.has(id)) {
        memoryStorage.set(id, new KeyValueStore());
    }
    return memoryStorage.get(id);
}
/**
 * @deprecated please use getOrCreateMemoryDataStore() instead
 */
export function createMemoryDataStore(id) {
    return getOrCreateMemoryDataStore(id);
}
/**
 * @deprecated please use getOrCreateMemoryCacheStore() instead
 */
export function createMemoryCacheStore(id) {
    return getOrCreateMemoryCacheStore(id);
}
function getOrCreateMemoryStorage() {
    const win = getGlobalThis();
    let storage = win[Symbol.for(storageId)];
    if (storage)
        return storage;
    storage = new UniversalMemoryStorage(storageId);
    win[Symbol.for(storageId)] = storage;
    return storage;
}
//# sourceMappingURL=memory-storage.js.map